import { inject, Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, shareReplay } from 'rxjs/operators';

import { BillingEstimateParams } from '@core/billing-types';
import { filterDefined } from '@core/common-legacy';
import { BillingEstimateActions, BillingEstimateSelectors } from '@recruitee/billing-data';

@Injectable({ providedIn: 'root' })
export class BillingEstimateDataService {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);

  public readonly data$ = this.store.select(BillingEstimateSelectors.data).pipe(
    filterDefined,
    shareReplay({
      bufferSize: 1,
      refCount: true,
    }),
  );
  public readonly isLoaded$ = this.store.select(BillingEstimateSelectors.isLoaded).pipe(
    filterDefined,
    shareReplay({
      bufferSize: 1,
      refCount: true,
    }),
  );
  public readonly isPending$ = this.store.select(BillingEstimateSelectors.isPending).pipe(
    filterDefined,
    shareReplay({
      bufferSize: 1,
      refCount: true,
    }),
  );
  public readonly fetchSuccess$ = this.actions$.pipe(
    ofType(BillingEstimateActions.fetchSuccess),
    map(action => action.payload),
  );
  public readonly fetchFailed$ = this.actions$.pipe(ofType(BillingEstimateActions.fetchFailed));

  public fetch(params: BillingEstimateParams) {
    this.store.dispatch(BillingEstimateActions.fetch({ payload: params }));
  }
}
